import React from 'react'
import { InputText } from "primereact/inputtext"
export const CustomInput = ({ className, error, ...props }) => {
    return (
        <InputText {...props} className={`${props.className} ${error ? "invalid_input" : ""} custom_input `} />
    )
}
